<template>
  <div class="user-mgt-page">
    <div class="global-header-wrap">
      <span>{{ $t("sale.coupon.title2") }}</span>
      <button class="global-button-style" @click="$router.back()">
        {{ $t("commonMsg.back") }}
      </button>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="120px"
          :model="coupons"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item :label="$t('sale.coupon.activity')" prop="name">
            <el-input
              v-model="coupons.name"
              class="fl"
              style="width: 100%"
              ref="name"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('sale.coupon.type')" prop="minus">
            <el-radio-group v-model="coupons.couponType" @change="changeRadio">
              <el-radio :label="1">{{
                $t("sale.coupon.discountCoupon")
              }}</el-radio>
              <el-radio :label="0">{{ $t("sale.coupon.deduction") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('sale.coupon.publishAt')" prop="publishAt">
            <el-date-picker
              style="width: 100%"
              v-model="coupons.publishAt"
              type="datetime"
              :picker-options="pickerOptions"
              :placeholder="$t('sale.coupon.inputPublishAt')"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            :label="$t('sale.coupon.minus')"
            prop="minus"
            v-if="coupons.couponType === 0"
          >
            <div>
              <el-input
                v-model="coupons.minus"
                class="fl"
                style="width: 100%"
                ref="minus"
                :placeholder="$t('sale.coupon.tips1')"
                @change="changeMinus"
                v-if="coupons.couponType === 0"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('sale.coupon.discount')"
            prop="discount"
            v-if="coupons.couponType === 1"
          >
            <div>
              <el-input
                v-model="coupons.discount"
                class="fl"
                style="width: 100%"
                ref="discount"
                :placeholder="$t('sale.coupon.tips2')"
                @change="changeMinus"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item :label="$t('sale.coupon.num')" prop="num">
            <el-input
              v-model="coupons.num"
              step="1"
              class="fl"
              style="width: 100%"
              :disabled="!!$route.query.id"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('sale.coupon.useRange')" prop="useRange">
            <el-radio-group v-model="coupons.useRange">
              <el-radio :label="0">{{ $t("sale.coupon.all") }}</el-radio>
              <el-radio :label="1">{{ $t("sale.coupon.monthly") }}</el-radio>
              <el-radio :label="2">{{ $t("sale.coupon.quarter") }}</el-radio>
              <el-radio :label="3">{{ $t("sale.coupon.year") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('sale.coupon.valid')" required>
            <el-col :span="11">
              <el-form-item prop="startAt">
                <el-date-picker
                  type="datetime"
                  :placeholder="$t('sale.coupon.inputStartAt')"
                  v-model="coupons.startAt"
                  :picker-options="pickerOptions0"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2" align="center">-</el-col>
            <el-col :span="11">
              <el-form-item prop="endAt">
                <el-date-picker
                  type="datetime"
                  :placeholder="$t('sale.coupon.inputEndAt')"
                  v-model="coupons.endAt"
                  :picker-options="pickerOptions1"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item :label="$t('sale.coupon.userList')" prop="userList">
            <el-input
              type="textarea"
              :rows="5"
              v-model="coupons.userList"
              @keyup.enter.native="checkPin(coupons.userList)"
              :disabled="!!$route.query.id"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <button class="global-button-style" @click="submitForm('ruleForm')">
              {{ $t("commonMsg.save") }}
            </button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    const checkDiscount = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("sale.coupon.verify1")));
      } else if (value > 1) {
        callback(new Error(this.$t("sale.coupon.verify2")));
      } else if (value < 0) {
        callback(new Error(this.$t("sale.coupon.verify3")));
      } else {
        callback();
      }
    };
    const limitVal = (rule, value, callback) => {
      let regs = /^([1-9]\d{0,})$/;
      if (value === "") {
        callback(new Error(this.$t("sale.coupon.verify4")));
      } else if (!regs.test(value)) {
        // 只能输入正整数
        callback(new Error(this.$t("sale.coupon.verify5")));
      } else {
        callback();
      }
    };
    return {
      coupons: {
        _id: "",
        name: "",
        publishAt: "",
        minus: 0,
        startAt: "",
        endAt: "",
        useLimit: 1,
        couponType: 1,
        useRange: 0,
        discount: 1,
        num: 1,
        userList: ""
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      pickerOptions0: {
        disabledDate: time => {
          if (this.coupons.endAt != "") {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() > this.coupons.endAt
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      pickerOptions1: {
        disabledDate: time => {
          return (
            time.getTime() < this.coupons.startAt ||
            time.getTime() < Date.now() - 8.64e7
          );
        }
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t("sale.coupon.inputActivity"),
            trigger: "change"
          }
        ],
        publishAt: [
          {
            required: true,
            message: this.$t("sale.coupon.inputPublishAt"),
            trigger: "change"
          }
        ],
        minus: [
          {
            required: true,
            message: this.$t("sale.coupon.inputMinus"),
            trigger: "change"
          }
        ],
        startAt: [
          {
            required: true,
            message: this.$t("sale.coupon.inputStartAt"),
            trigger: "change"
          }
        ],
        endAt: [
          {
            required: true,
            message: this.$t("sale.coupon.inputEndAt"),
            trigger: "change"
          }
        ],
        useLimit: [
          {
            required: true,
            message: this.$t("sale.coupon.inputNum"),
            trigger: "change"
          }
        ],
        num: [{ validator: limitVal, required: true, trigger: "change" }],
        discount: [{ validator: checkDiscount, required: true }]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit();
          } else {
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    create() {
      let params = {
        name: this.coupons.name,
        publishAt: this.coupons.publishAt,
        minus: parseFloat(this.coupons.minus),
        startAt: this.coupons.startAt,
        endAt: this.coupons.endAt,
        num: this.coupons.num,
        useRange: this.coupons.useRange,
        userList: this.coupons.userList,
        couponType: this.coupons.couponType,
        discount: parseFloat(this.coupons.discount)
      };
      this.$http.createCoupons(params).then(ret => {
        this.$router.back();
        this.$message({
          showClose: true,
          message: this.$t("sale.coupon.tips3"),
          type: "success",
          duration: 1000
        });
      });
    },

    edit() {
      let params = {
        name: this.coupons.name,
        publishAt: this.coupons.publishAt,
        minus: parseFloat(this.coupons.minus),
        startAt: this.coupons.startAt,
        endAt: this.coupons.endAt,
        useRange: this.coupons.useRange,
        userList: this.coupons.userList,
        couponType: this.coupons.couponType,
        discount: parseFloat(this.coupons.discount)
      };
      this.$http.editCoupons(this.$route.query.id, params).then(ret => {
        this.$router.back();
        this.$message({
          showClose: true,
          message: this.$t("alertMsg.modifySuccess"),
          type: "success",
          duration: 1000
        });
      });
    },

    getCouponsDetails() {
      this.$http.getCouponsDetails(this.$route.query.id).then(res => {
        this.coupons = { ...this.coupons, ...res[0] };
      });
    },

    checkPin(val) {
      let arrTemp = val.split(/[\n]/);
      if (arrTemp.length > this.coupons.num) {
        arrTemp.pop(); // 去除空值
        this.coupons.userList = arrTemp.join("\n");
        this.$message({
          showClose: true,
          message: this.$t("sale.coupon.tips4"),
          type: "warning",
          duration: 1000
        });
      }
    },
    changeRadio(val) {
      if (val === 1) {
        this.coupons.minus = 0;
      } else {
        this.coupons.discount = 1;
      }
    },
    changeMinus(val) {
      if (val <= 0) {
        this.coupons.minus = 0;
        this.$refs.minus.focus();
      }
    }
  },
  mounted() {
    if (!this.$route.query.id) return;
    this.getCouponsDetails();
  }
};
</script>

<style lang="scss">
.user-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
    }
  }
}
</style>
